module.exports = __webpack_public_path__ + "711c41362d6827f1916be5b8f1c4a9ac.jpg";